/* ============================================================
   STRUKT — product-form.js
   Variant selection, quantity stepper, gallery sync, sticky ATC,
   and Ajax add-to-cart for the product page. Loaded only on
   product templates.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  var form = qs('#ProductForm');
  if (!form) return;

  var jsonEl = qs('[data-product-json]');
  var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

  var labelsEl = qs('[data-product-labels]');
  var labels = labelsEl ? JSON.parse(labelsEl.textContent) : { available: 'Add to cart', soldOut: 'Sold out' };

  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + '.' + parts[1];
    return format
      .replace('{{amount}}', withComma)
      .replace('{{amount_no_decimals}}', parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
  }

  /* ---------- variant selection ---------- */
  function currentSelection() {
    var values = [];
    qsa('[data-option-index]', form).forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[data-option-value]:checked');
      values[+fieldset.dataset.optionIndex] = checked ? checked.value : null;
    });
    return values;
  }

  function findVariant(values) {
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return val === values[i]; });
    });
  }

  function updateForVariant(variant) {
    var priceEls = qsa('[data-price]');
    var compareEls = qsa('[data-compare-price]');
    var addBtn = qs('[data-add-to-cart]', form);
    var addText = qs('[data-add-to-cart-text]', form);
    var stockDot = qs('[data-stock-dot]', form);
    var stockText = qs('[data-stock-text]', form);
    var idInput = qs('[data-variant-id]', form);
    var stickyBtn = qs('[data-sticky-atc] [data-quick-add]');

    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addText) addText.textContent = 'Unavailable';
      return;
    }

    if (idInput) idInput.value = variant.id;
    priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    compareEls.forEach(function (el) {
      if (onSale) {
        el.textContent = formatMoney(variant.compare_at_price);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });

    if (addBtn) addBtn.disabled = !variant.available;
    if (addText) addText.textContent = variant.available ? labels.available : labels.soldOut;
    if (stockDot) {
      stockDot.classList.toggle('stock-dot--in', variant.available);
      stockDot.classList.toggle('stock-dot--out', !variant.available);
    }
    if (stockText) stockText.textContent = variant.available ? 'In stock, ready to ship' : 'Currently out of stock';
    if (stickyBtn) {
      stickyBtn.dataset.variantId = variant.id;
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = variant.available ? (labels.stickyAvailable || labels.available) : labels.soldOut;
    }

    if (variant.featured_image) {
      var slide = qs('[data-gallery-slide][data-media-id="' + variant.featured_image.id + '"]');
      if (slide) setActiveSlide(slide.dataset.index);
    }
  }

  qsa('input[data-option-value]', form).forEach(function (input) {
    input.addEventListener('change', function () {
      var variant = findVariant(currentSelection());
      updateForVariant(variant);
    });
  });

  /* ---------- quantity stepper ---------- */
  var qtyInput = qs('[data-qty-input]', form);
  var qtyWrapper = qs('[data-qty-wrapper]', form);
  if (qtyWrapper && qtyInput) {
    qtyWrapper.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-qty-decrease]');
      var inc = e.target.closest('[data-qty-increase]');
      var val = parseInt(qtyInput.value, 10) || 1;
      if (dec) val = Math.max(1, val - 1);
      if (inc) val = val + 1;
      qtyInput.value = val;
    });
  }

  /* ---------- gallery: arrows + sliding track (+ swipe) ---------- */
  var galleryEl = qs('[data-gallery]');
  var galleryTrack = galleryEl ? qs('[data-gallery-track]', galleryEl) : null;
  var gallerySlides = galleryEl ? qsa('[data-gallery-slide]', galleryEl) : [];
  var galleryDots = galleryEl ? qsa('[data-gallery-dot]', galleryEl) : [];
  var galleryIndex = 0;

  function setActiveSlide(index) {
    var count = gallerySlides.length;
    if (!count) return;
    index = ((Number(index) % count) + count) % count; /* wrap around */
    galleryIndex = index;
    if (galleryTrack) galleryTrack.style.transform = 'translateX(' + (-100 * index) + '%)';
    gallerySlides.forEach(function (slide) {
      slide.classList.toggle('is-active', Number(slide.dataset.index) === index);
    });
    galleryDots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
  }

  if (galleryEl) {
    var prevBtn = qs('[data-gallery-prev]', galleryEl);
    var nextBtn = qs('[data-gallery-next]', galleryEl);
    if (prevBtn) prevBtn.addEventListener('click', function () { setActiveSlide(galleryIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setActiveSlide(galleryIndex + 1); });

    /* swipe */
    var startX = null, startY = null;
    galleryEl.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    galleryEl.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) setActiveSlide(galleryIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* ---------- sticky add-to-cart ---------- */
  var stickyAtc = qs('[data-sticky-atc]');
  var mainSubmit = qs('[data-add-to-cart]', form);
  if (stickyAtc && mainSubmit && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(mainSubmit);
  }

  /* ---------- ajax submit ---------- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var idInput = qs('[data-variant-id]', form);
    var addBtn = qs('[data-add-to-cart]', form);
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    if (!idInput || !idInput.value) return;
    if (addBtn) addBtn.disabled = true;

    fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: idInput.value, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (window.dispatchEvent) window.dispatchEvent(new CustomEvent('strukt:toast', { detail: data.description || 'Could not add that to your cart.' }));
          return;
        }
        return Promise.all([
          fetch('/cart.js').then(function (r) { return r.json(); }),
          fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); })
        ]).then(function (results) {
          var cart = results[0];
          var html = results[1];
          qsa('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
          });
          var doc2 = new DOMParser().parseFromString(html, 'text/html');
          var newDrawer = doc2.querySelector('[data-cart-drawer]');
          var oldDrawer = qs('[data-cart-drawer]');
          if (newDrawer && oldDrawer) oldDrawer.replaceWith(newDrawer);
          var drawer = qs('[data-cart-drawer]');
          if (drawer) {
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            doc.body.style.overflow = 'hidden';
          }
        });
      })
      .finally(function () { if (addBtn) addBtn.disabled = false; });
  });
})();
